module.exports = __webpack_public_path__ + "img/外发录入.57062516.svg";